import useAuthenticatedRequest from '@Infowijs-eng/component-library/hooks/useAuthenticatedRequest'
import { useQuery } from '@tanstack/react-query'
import getBruggerEndpoint from '../../modules/getBruggerEndpoint'
import { PreferredLAS } from '../../types'

export default function useLASOrganisationalUnits(
  customerProductName: string,
  las: PreferredLAS,
  organisationId: string,
) {
  const fetch = useAuthenticatedRequest()
  const bruggerEndpoint = customerProductName ? getBruggerEndpoint(customerProductName) : undefined

  return useQuery({
    queryKey: ['las-organisational-units', las, organisationId, customerProductName],
    queryFn: async () => {
      const params = new URLSearchParams([
        ['las', las],
        ['organisationId', organisationId],
      ])

      const response = await fetch(`${bruggerEndpoint}/api/exporters/organisational-units?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return response.data as {
        id: string
        name: string
        brins: string[]
      }[]
    },
    enabled: !!customerProductName && !!las && !!organisationId,
  })
}
